<div class="line-colour-selector-div">
  <input
    #input
    (focus)="selectText()"
    (keyup)="onSelectionChange($event)"
    [(ngModel)]="value"
    [disabled]="params?.data?._tags?.includes('disabled') && !params?.context?.isStockManager"
    class="input"/>
  <select
    (change)="onSelectionChange($event)"
    [(ngModel)]="value"
    [disabled]="params?.data?._tags?.includes('disabled') && !params?.context?.isStockManager"
    class="select-line-colour-list">
    @if (colDefField === 'lineColourCode') {
      <option value="0">
        No Line Colour
      </option>
    }
    @for (option of options; track $index) {
      <option
        [style.background]="option.value ? option.value : 'var(--gallix-color-light-v1)'"
        [value]="option.key">
        {{ option.description }}
      </option>
    }
  </select>
  @if (params.data.originalValue[params.colDef.field].value !== value) {
    <app-display-icon
      (click)="onUndoChangesClick()"
      [icon]="icons.backSpaceOutline"
      class="backspace">
    </app-display-icon>
  }
</div>
